module.exports = __webpack_public_path__ + "img/style_model_preview_2.50036661.jpg";